import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function ProofSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-950 relative overflow-hidden" data-id="element-155">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-5" data-id="element-156" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-gradient-to-b from-navy-800 to-navy-900 border border-gold-500/20 rounded-2xl p-8 md:p-12 text-center shadow-2xl" data-id="element-158">
          <Sparkles className="w-10 h-10 text-gold-400 mx-auto mb-6" data-id="element-159" />

          <h2 className="text-3xl md:text-4xl font-serif text-white mb-10" data-id="element-160">
            Lo que cambia en 7 días:
          </h2>

          <ul className="space-y-6 text-left max-w-xl mx-auto" data-id="element-161">
            {['Notarás que las discusiones de otros ya no te afectan físicamente.', 'Dejarás de llegar a casa con la necesidad de dormir 10 horas para recuperarte de una simple charla.', 'Tu mente se sentirá clara y tu cuerpo, por fin, te pertenecerá solo a ti.'].map((text, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3 + i * 0.1
          }} className="flex items-start gap-4" data-id="element-162">
                <div className="w-2 h-2 rounded-full bg-gold-400 mt-2 flex-shrink-0" data-id="element-163" />
                <p className="text-lg text-gray-200 leading-relaxed font-light" data-id="element-164">
                  {text}
                </p>
              </motion.li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}